import { IChannel } from "../interfaces/IChannel.ts";
import { IEpgItem } from "../interfaces/IEpgItem.ts";
import DateHelper from "./dateHelper.ts";

export default class ChannelHelpers {
    public static getActualEpg(channel: IChannel): IEpgItem | null {
        const actualEpg = channel.epgList.find(x => x.start_timestamp < DateHelper.GetDateTimeNowAsUnixTimespan() && x.stop_timestamp >= DateHelper.GetDateTimeNowAsUnixTimespan());
        if (actualEpg)
            return actualEpg;
        return null;
    }
}
